import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import "./styles/animated-on3step.css";
import "./styles/main.scss";

import Preloader from "./components/Preloader";
import NavigationMenu from "./components/Nav";
import ScrollToTopBtn from './components/ScrollToTop';
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Newsdetail from "./pages/NPLEXBlog";
import Services from "./pages/Services";
import WOW1 from "./pages/WOW1";
import WOW2 from "./pages/WOW2";
import WOW3 from "./pages/WOW3";
import WOW4 from "./pages/WOW4";
import WOW5 from "./pages/WOW5";
import WOW6 from "./pages/WOW6";
import WOW7 from "./pages/WOW7";
import WOW8 from "./pages/WOW8";
import WOW9 from "./pages/WOW9";
import WOW10 from "./pages/WOW10";
import WOW11 from "./pages/WOW11";
import WOW12 from "./pages/WOW12";
import WOW13 from "./pages/WOW13";
import WOW14 from "./pages/WOW14"

function App() {
  const [loading, setLoading] = useState(true);
  const [navBackground, setNavBack] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, [loading]);

  return (
    <Router>
      {loading ? (
        <Preloader />
      ) : (
        <div className="App">
          <NavigationMenu
            firstTime={loading}
            hasBackground={navBackground}
            setBackground={state => setNavBack(state)}
          />
          <Route path="/" exact component={Home} />
          <Route path="/About" exact component={About} />
          <Route path="/Services" exact component={Services} />
          <Route path="/Blog" exact component={Blog} />
          <Route path="/Contact" exact component={Contact} />



          <Route
            path="/NPLEXBlog"
            component={() => (
              <Newsdetail setNavBackground={state => setNavBack(state)} />
            )}
          />
          <Route
            path="/WOW1"
            component={() => (
              <WOW1 setNavBackground={state => setNavBack(state)} />
            )}
          />
          <Route
            path="/WOW2"
            component={() => (
              <WOW2 setNavBackground={state => setNavBack(state)} />
            )}
          />
          <Route
            path="/WOW3"
            component={() => (
              <WOW3 setNavBackground={state => setNavBack(state)} />
            )}
          />
          <Route
            path="/WOW4"
            component={() => (
              <WOW4 setNavBackground={state => setNavBack(state)} />
            )}
          />
           <Route
            path="/WOW5"
            component={() => (
              <WOW5 setNavBackground={state => setNavBack(state)} />
            )}
          />
           <Route
            path="/WOW6"
            component={() => (
              <WOW6 setNavBackground={state => setNavBack(state)} />
            )}
          />
           <Route
            path="/WOW7"
            component={() => (
              <WOW7 setNavBackground={state => setNavBack(state)} />
            )}
          />
           <Route
            path="/WOW8"
            component={() => (
              <WOW8 setNavBackground={state => setNavBack(state)} />
            )}
          />
           <Route
            path="/WOW9"
            component={() => (
              <WOW9 setNavBackground={state => setNavBack(state)} />
            )}
          />
           <Route
            path="/WOW10"
            component={() => (
              <WOW10 setNavBackground={state => setNavBack(state)} />
            )}
          />
           <Route
            path="/WOW11"
            component={() => (
              <WOW11 setNavBackground={state => setNavBack(state)} />
            )}
          />
           <Route
            path="/WOW12"
            component={() => (
              <WOW12 setNavBackground={state => setNavBack(state)} />
            )}
          />
          <Route
            path="/WOW13"
            component={() => (
              <WOW13 setNavBackground={state => setNavBack(state)} />
            )}
          />
          <Route
            path="/WOW14"
            component={() => (
              <WOW14 setNavBackground={state => setNavBack(state)} />
            )}
          />
          
        <ScrollToTopBtn />  
        </div>
      )}
    </Router>
  );
}

export default App;